module.exports = __webpack_public_path__ + "img/leftewm.7fc2a93d.jpg";